import i18n from "src/i18n";


export const getPatientNavLinks = () => [
  {
    id: 1,
    label: i18n.t("profile"),
    value: "profile",
  },
  {
    id: 2,
    label: i18n.t("timeline"),
    value: "timeline",
  },
  {
    id: 3,
    label: i18n.t("consultation"),
    value: "consultation",
  },
  {
    id: 4,
    label: i18n.t("laboratory"),
    value: "laboratory",
  },
  {
    id: 5,
    label: i18n.t("radiology"),
    value: "radiology",
  },
  {
    id: 6,
    label: i18n.t("prescription"),
    value: "prescription",
  },
  {
    id: 7,
    label: i18n.t("immunization"),
    value: "immunization",
  },
  // {
  //   id: 8,
  //   label: "Notes",
  // },
  {
    id: 9,
    label: i18n.t("records"),
    value: "records",
  },
  {
    id: 10,
    label: i18n.t("billing"),
    value: "billing",
  },
];
